import styled from 'styled-components';
import { ApRadio, colors } from '@alixpartners/ui-components';

export const Radio = styled(ApRadio)`
	margin-right: 6px;
`;

export const RadioWrapper = styled.div`
	margin-top: 30px;

	label {
		font-size: 16px !important;
		margin-left: 6px;
		margin-top: 20px;
	}
`;

export const SelectWrapper = styled.div`
	width: 150px;
	position: relative;
	top: -34px;
	left: 220px;
	margin-bottom: -32px;

	label {
		display: none;
	}

	& span {
		line-height: 24px;
		border-color: ${colors.grey4};
	}
`;
